import React from 'react';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import CuponesData from '../../Components/Admin/CuponesData/CuponesData';

export default function Cupones() {
    return (
        <div className="containerGrid">
            <Header />
            <section className="containerSection">
                <HeaderDash />
                <div className="container">
                    <CuponesData />
                </div>
            </section>
        </div>
    );
}
